import { useQuery } from '@tanstack/react-query'
import { healthCyclesAPI } from '../../services/api'

export function useGoalProgress() {
  return useQuery({
    queryKey: ['healthCycleGoalProgress'],
    queryFn: () => healthCyclesAPI.goalProgress(),
    select: (r) => r.data,
  })
}
